module.exports = require("./crossfilter").crossfilter;



/*****************
 ** WEBPACK FOOTER
 ** ./~/crossfilter/index.js
 ** module id = 313
 ** module chunks = 0
 **/